// @ts-check

/** @file Persists only Velocious's privacy-safe coordinator snapshot per project replica. */

import ReplicaMetadata from "../models/replica-metadata.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER} from "./project-replica-contract.js"

/** @import TenantHandle from "velocious/build/src/tenants/tenant-handle.js" */
/** @import {SyncCoordinatorStatusStore} from "velocious/build/src/sync/sync-coordinator-types.js" */

const STATUS_KEY = "sync-coordinator-status-v1"

/**
 * Creates a safe durable coordinator-status store in the project replica.
 * @param {TenantHandle} handle Captured project handle.
 * @param {{beforeSave?: () => Promise<void>}} [options] Durability boundary options.
 * @returns {SyncCoordinatorStatusStore} Durable status store.
 */
export function createProjectReplicaStatusStore(handle, options = {}) {
  const {beforeSave = async () => {}} = options

  return {
    load: async () => await handle.databaseOperation({databaseIdentifier: PROJECT_REPLICA_DATABASE_IDENTIFIER}, async (operation) => {
      const row = await operation.forModel(ReplicaMetadata).findBy({key: STATUS_KEY})

      return row ? JSON.parse(row.value()) : null
    }),
    save: async (status) => {
      await beforeSave()
      await handle.transaction({databaseIdentifier: PROJECT_REPLICA_DATABASE_IDENTIFIER}, async (operation) => {
        const metadata = operation.forModel(ReplicaMetadata)
        const row = await metadata.findOrInitializeBy({key: STATUS_KEY})

        row.setValue(JSON.stringify(status))
        await row.save()
      })
      await handle.flush({databaseIdentifier: PROJECT_REPLICA_DATABASE_IDENTIFIER})
    }
  }
}
